import { TFunction } from 'i18next'

export const getPricing = (t: TFunction<'translation', undefined>) => ({
  list: [
    t('addons.store.import-from-figma.pricing.list.1'),
    t('addons.store.import-from-figma.pricing.list.2'),
    t('addons.store.import-from-figma.pricing.list.3')
  ]
})
